import styled from "styled-components";
import { TextTheme, ButtonTheme, ColorTheme, SpacingTheme } from "../globaStyledComponents/globalStyledComponentsStyling";

export const GlobalBookingGuestPickerGuestsWrapper = styled.div`
    min-height: 260px;
    width: 100%;
    padding-top: 40px;
    margin-bottom: 45px;
    display: flex;
    flex-direction: column;
`;

export const GlobalBookingGuestPickerGuestsTitleWrapper = styled.div`
    width: calc(100% - 48px);
    display: grid;
    margin: 0 24px;
    align-items: center;
    grid-template-columns: 100%;
    grid-template-rows: 100%;

    @media (min-width: 768px) {
        width: calc(100% - 48px);
        margin: 0 auto;
    }
`;

export const GlobalBookingGuestPickerGuestsTitleTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    grid-column: 1/2;
    grid-row: 1/2;
    justify-self: start;
`;

export const GlobalBookingGuestPickerGuestsTitle = styled.p`
    position: relative;
    font-size: 22px;
    font-family: ${TextTheme.sans_500_semi.fontFamily};
    line-height: ${TextTheme.sans_500_semi.lineHeight};
    color: ${ColorTheme.Black.color};
    text-align: left;
    margin: 0;
`;

export const GlobalBookingGuestPickerGuestsSubtitle = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    max-width: 180px;
    text-align: left;
    margin: 0;
    margin-top: 8px;
    margin-bottom: 32px;

    @media (min-width: 768px) {
        margin-bottom: 16px;
        max-width: none;
    }

    strong {
        font-family: ${TextTheme.sans_300_semi.fontFamily};
    }
`;

export const GlobalBookingGuestPickerRow = styled.div`
    width: calc(100% - 48px);
    margin: 0 auto;
    padding: ${SpacingTheme.spacing_400.padding} 0 ${SpacingTheme.spacing_400.padding};
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (min-width: 768px) {
        border: none !important;
        padding: ${SpacingTheme.spacing_300.padding} 0 ${SpacingTheme.spacing_300.padding};
    }
`;

export const GlobalBookingGuestPickerRowTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SpacingTheme.spacing_100.gap};
`;

export const GlobalBookingGuestPickerRowTextTitle = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    margin: 0;
`;

export const GlobalBookingGuestPickerRowTextSubtitle = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
    margin: 0;
`;

export const GlobalBookingGuestPickerButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 112px;
    justify-content: space-between;
`;

interface GlobalBookingGuestPickerButtonProps {
    disabled?: boolean;
}
export const GlobalBookingGuestPickerButton = styled.button<GlobalBookingGuestPickerButtonProps>`
    height: 34px;
    width: 34px;
    border: 1px solid ${props => props.disabled ? ColorTheme.Grey2.color : ColorTheme.Grey1.color};
    background: none;
    border-radius: 50%;
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    font-family: ${ButtonTheme.sans_button_100.fontFamily};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${props => props.disabled ? 0.5 : 1};
`;

export const GlobalBookingGuestPickerRowTextNotAllowed = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    color: ${ColorTheme.Grey1.color};
    margin: 0;
`;